import { useEffect, useCallback, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { createAction, createActionType } from '@ers/helpers/';
import isLoading from './LazyOpen.selectors';
import ActionTypes from './LazyOpen.actions';

const useLazyOpen = (name, namespace, identifiers, selector, openCallback) => {
    const key = `${identifiers.join('_')}`;
    const { current: addLoading } = useRef(createAction(ActionTypes.addLoading[name]));
    const { current: removeLoading } = useRef(createAction(ActionTypes.removeLoading[name]));
    const { current: fetch } = useRef(createAction(createActionType(`fetch${name}`)(namespace)));
    const loadingStarted = useSelector((state) => isLoading[name](state, { key }));
    const entity = useSelector((state) => selector(state, { key }));
    const dispatch = useDispatch();
    const isEntityLoading = !entity && loadingStarted;
    useEffect(() => {
        if (entity && loadingStarted) {
            openCallback(entity);
            dispatch(removeLoading({ payload: { key } }));
        }
    }, [entity]);
    const open = useCallback(() => {
        if (!entity && !loadingStarted) {
            dispatch(fetch({ payload: { key } }));
            dispatch(addLoading({ payload: { key } }));
        } else if (entity) {
            openCallback(entity);
        }
    }, [entity, loadingStarted]);
    return { open, isLoading: isEntityLoading, key };
};
export default useLazyOpen;